import React from 'react';

import { View, Text, Image, StyleSheet } from 'react-native';

import OPComponent from './op_component';
import I18n from '../../I18n';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

export default class NoAccess extends OPComponent {
  render() {
    return (
      <View style={styles.container}>
        {/*<Image
          source={require('../../../resources/nav-icon-messaging.png')}
          style={styles.icon}
        />*/}
        <Text style={styles.text}>{I18n.t('noAccess')}</Text>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 125,
    paddingHorizontal: 25,
  },
  icon: {
    width: 70,
    height: 70,
    // tintColor: COLOR.emphasis
  },
  text: {
    ...FONT.medium,
    fontSize: FONT_SIZE.large,
    marginTop: 20,
  },
});
